export const advantage = [
  {
    id: 1,
    iconName: "architecture",

    title: "Historické budovy",
    paragraph:
      "Podnikejte v budovách s jedinečnou historií a charakterem, které dodají vašemu podnikání prestiž a styl.",
  },

  {
    id: 2,
    iconName: "location_on",
    title: "Centrum města",
    paragraph:
      "V srdci Bohumína máte vše po ruce – úřady, obchody, restaurace a klidné náměstí pro odpočinek během dne.",
  },

  {
    id: 3,
    iconName: "commute",
    title: "Skvělá dostupnost",
    paragraph:
      "Jen pár minut chůze od autobusové i vlakové stanice, takže vaši zákazníci a zaměstnanci vás snadno najdou.",
  },

  {
    id: 4,
    iconName: "parking_sign",
    title: "Parkování",
    paragraph:
      "K dispozici je jedno parkovací místo na soukromém pozemku spadající k budouvě na Komenského ulici a další parkování je možné na veřejných parkovištích před i za oběma budovami.",
  },
];
